'use client';

export const GlobalStyle = () => {
  return (
    // eslint-disable-next-line react/no-unknown-property
    <style id="antiClickjack" jsx>
      {`
        body {
          display: none;
        }
      `}
    </style>
  );
};
